import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        refBenutzer: 0,
        eMail: '',
        name: '',
        vorname: '',
        istAdmin: 0,
        primVerein: 0,
        nameVerein: '',
        stadt: ''
    }
});

export default store;